var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Spin',{attrs:{"fix":"","size":"large"}},[_c('Icon',{staticClass:"demo-spin-icon-load",attrs:{"type":"ios-loading","size":"18"}}),_c('div',[_vm._v("加载中...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }